export class FormFeedbackRequest {
  id?: number;
  fullName: string;
  email: string;
  tukeRelationshipCode: number;
  comment: string;
}
